<template>
  <modal
    @before-close="modalClose"
    @before-open="modalOpen"
    :name="`${modal}${prefix}`"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
    :width="800"
  >
  <div class="shadow-wrapper" @click="closeModal"></div>
    <card v-if="model">
      <div class="add-control">
        <p-button class="mr-2" round @click.native.prevent="closeModal">
          <span class="ti-arrow-left"></span> <span class="m-l-1">Назад</span>
        </p-button>
        <p-button class="" type="info" @click.native.prevent="accept">Применить</p-button>
      </div>
      <hr />

      <list
        :columns="model.columns"
        :modalCreate="model.modalCreate"
        :removeLink="model.removeLink"
        :cardLink="model.cardLink"
        :isUpdate="model.isUpdate"
        :params="p"
        :isAdd="model.isAdd"
        :itemLink="sL + pushLink"
        :setLink="sL + pushLink"
        :openItem="model.openItem"
        :fields="model.fields"
        :searchDisable="model.searchDisable"
        v-model="val"
        :simple="simple"
      />
      <hr />
      <div class="add-control">
        <p-button class="mr-2" round @click.native.prevent="closeModal">
          <span class="ti-arrow-left"></span><span class="m-l-1">Назад</span>
        </p-button>
        <p-button class="" type="info" @click.native.prevent="accept">Применить</p-button>
      </div>
    </card>
  </modal>
</template>
<script>
import List from "../List";

export default {
  name: "ListItem",
  data() {
    return {
      val: [],
      p: {},
      sL: "",
    };
  },
  props: {
    pushLink: {
      default: function () {
        return "";
      },
    },
    modal: {
      default: function () {
        return "";
      },
    },
    disabled: {
      default: function () {
        return false;
      },
    },
    params: {
      default: function () {
        return {};
      },
    },
    prefix: {
      default: function () {
        return "";
      },
    },
    setLink: {
      default: function () {
        return "";
      },
    },
    simple: {
      default: false,
    },
    value: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    model: {
      get() {
        return this.$store.state.modals[this.modal];
      },
    },
  },
  created() {
    this.val = this.value;
    this.p = {};

    if (
      this.model &&
      this.model.params &&
      Object.getPrototypeOf(this.model.params) === Object.prototype &&
      Object.keys(this.model.params).length
    ) {
      this.p = { ...this.p, ...this.model.params };
    }

    if (
      this.params &&
      Object.getPrototypeOf(this.params) === Object.prototype &&
      Object.keys(this.params).length
    ) {
      this.p = { ...this.p, ...this.params };
    }

    this.sL = this.setLink ? this.setLink : this.model["itemLink"];
  },
  watch: {
    value(val) {
      this.val = val;
    },
  },
  components: {
    List,
  },
  methods: {
    modalClose() {},
    modalOpen() {},
    closeModal() {
      this.$modal.hide(`${this.modal}${this.prefix}`);
    },
    accept() {
      if (this.val) {
        this.$modal.hide(`${this.modal}${this.prefix}`);
        this.$emit("input", this.val);
        this.val = [];
      }
    },
  },
};
</script>

